export const NAV_ITEMS = [
  { label: 'Home', pageKey: 'Home' },
  { label: 'Vision & Philosophy', pageKey: 'Vision & Philosophy' },
  {
    label: 'Products',
    children: [
      {
        label: 'Heka Atlas',
        page: 'HekaAtlas',      // 👈 maps to PAGE_COMPONENTS key 
        path: '/HekaAtlas'  // 👈 URL for this menu path
      },
      {
        label: 'Heka Codex',
        page: 'HekaCodex',      // 👈 maps to PAGE_COMPONENTS key 
        path: '/HekaCodex'  // 👈 URL for this menu path
      },
      {
        label: 'Heka Odyssey',
        page: 'HekaOdyssey',      // 👈 maps to PAGE_COMPONENTS key 
        path: '/HekaOdyssey'  // 👈 URL for this menu path
      },
    ],
  },
  {
    label: 'Intelligence Corner', pageKey: 'Intelligence Corner',
    children: [
      {
        label: 'Articles',
        page: 'Article',      // 👈 maps to PAGE_COMPONENTS key 
        path: '/resources/articles'  // 👈 URL for this menu path
      },
      {
        label: 'API Reference',
        page: 'APIReference',      // 👈 maps to PAGE_COMPONENTS key 
        path: '/resources/api-reference'  // 👈 URL for this menu path
      },
      {
        label: 'Documentation',
        page: 'Documentation',      // 👈 maps to PAGE_COMPONENTS key 
        path: '/resources/documentation'  // 👈 URL for this menu path
      }
    ],
  },
  { label: 'Career', pageKey: 'Career' },
  { label: 'Connect', pageKey: 'Connect' },

];
